import React from "react";
import { Link } from "react-router-dom";
import * as Api from "../api/authentication";
import TextInput from "./common/TextInput";

class LoginPage extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            userName: "",
            password: "",
            error: false
        };
        this.handleChange = this.handleChange.bind(this);
        this.handleSave = this.handleSave.bind(this);
    }

    handleChange(event) {
        let value = event.target.value;
        this.setState({ [event.target.id]: value });
        this.setState({ error: false });
    }

    async handleSave(event) {
        event.preventDefault();

        let authResp = await Api.authenticate({
            userName: this.state.userName,
            password: this.state.password
        });
        debugger;
        if (authResp) 
            this.props.onAuth(authResp);
        else
            this.setState({ error: true });
    }

    render() {
        return (
            <>
                <div className="form-group">
                    <label>Iniciar sesi&#243;n</label>

                    <form onSubmit={this.handleSave}>
                        {" "}
                        <div className={"form-group" + (this.state.error ? " has-error" : "")}>
                            <TextInput
                                id="userName"
                                label="Usuario"
                                value={this.state.userName}
                                onChange={this.handleChange}
                            />
                            <div className="form-group row">
                                <label
                                    htmlFor="password"
                                    className="col-sm-2 col-lg-2 col-form-label"
                                >
                                    Contraseña
                                </label>
                                <div className="col-sm-10 col-lg-6 field">
                                    <input
                                        id="password"
                                        type="password"
                                        className="form-control"
                                        value={this.state.password}
                                        onChange={event => {
                                            this.handleChange(event);
                                        }}
                                    />
                                </div>
                            </div>
                            {this.state.error && (
                                <div className="alert alert-danger">
                                    Usuario &#243; Contraseña incorrecta
                                </div>
                            )}
                            <input type="submit" value="Entrar" className="btn btn-primary" />
                        </div>
                    </form>

                    <div>
                        <label>No tienes cuenta?</label>
                        <Link to={"/Register"} className="btn btn-primary btn-sm">
                            Registrate
                        </Link>
                    </div>
                </div>
            </>
        );
    }
}
export default LoginPage;
